import Layout from "@components/Layout"
import haptics from "@helpers/haptics"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

interface YesNoQuestionPageProps {
  translationKey: string
}

const OPTIONS = [
  { key: "yes", emoji: "👍" },
  { key: "no", emoji: "👎" },
] as const

export default function YesNoQuestionPage({
  translationKey,
}: YesNoQuestionPageProps) {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    haptics.trigger("selection")
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <h1 className="heading">
        {t(`pages.onboarding.${translationKey}.heading`)}
      </h1>

      <Form className="custom-form" method="post">
        <div className="flex grow flex-col justify-center">
          <div className="flex items-center justify-center gap-4">
            {OPTIONS.map(({ key, emoji }) => (
              <label
                key={key}
                className="bg-card hover:bg-card-hover flex h-32 w-32 cursor-pointer flex-col items-center justify-center gap-2 rounded-2xl border-2 border-gray-700/50 p-3 transition-all duration-200 hover:border-gray-600/50"
              >
                <input
                  type="radio"
                  name={t(`pages.onboarding.${translationKey}.heading`, {
                    lng: "en",
                  })}
                  value={t(`pages.onboarding.${translationKey}.${key}`, {
                    lng: "en",
                  })}
                  onChange={handleChange}
                  className="hidden"
                />
                <div className="bg-card-elevated flex h-14 w-14 shrink-0 items-center justify-center rounded-xl p-2">
                  <span className="emoji text-3xl leading-none">{emoji}</span>
                </div>
                <span className="text-text-primary font-semibold">
                  {t(`pages.onboarding.${translationKey}.${key}`)}
                </span>
              </label>
            ))}
          </div>
        </div>
      </Form>
    </Layout>
  )
}
